module.exports = __webpack_public_path__ + "img/el-ic-position.5bb48342.svg";